import { validarResultado } from "./validarResultado";

export async function postFetch(url, body, callbackSucesso, callbackErro, callbackErroConexao, exibirToastErroConexao, exibirToastErroServidor, headers = { }) {
    const retorno = await fetch(url, {
        method: 'POST',
        body: body,
        headers,
    });

    return validarResultado(retorno, callbackSucesso, callbackErro, callbackErroConexao, exibirToastErroConexao, exibirToastErroServidor);
}
